// services/config.js
const API_BASE_URL = 'https://node.sriramsias.com/';

export default API_BASE_URL;
